import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import Frame from '../components/Frame.tsx';
import DonutChart from '../components/DonutChart';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "donut-chart"
    }}>{`Donut Chart`}</h1>
    <p>{`See the component `}<a parentName="p" {...{
        "href": "https://github.com/kristw/encodable/tree/master/packages/docs/src/components/DonutChart"
      }}>{`source code`}</a>{`.
or play with the component API by editing the code below.`}</p>

    <Playground __position={0} __code={'<Frame width={360} height={270} background=\"#556270\">\n  <DonutChart\n    width={360}\n    height={270}\n    encoding={{\n      color: {\n        type: \'nominal\',\n        field: \'id\',\n        scale: {\n          type: \'ordinal\',\n          range: [\'#4ECDC4\', \'#C7F464\', \'#FF6B6B\', \'#C44D58\'],\n        },\n      },\n      pattern: { value: \'lines\' },\n      size: { type: \'quantitative\', field: \'value\' },\n      label: { field: \'id\' },\n    }}\n    data={[\n      {\n        id: \'python\',\n        value: 376,\n      },\n      {\n        id: \'javascript\',\n        value: 392,\n      },\n      {\n        id: \'ruby\',\n        value: 331,\n      },\n      {\n        id: \'scala\',\n        value: 184,\n      },\n    ]}\n  />\n</Frame>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Frame,
      DonutChart,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Frame width={360} height={270} background="#556270" mdxType="Frame">
    <DonutChart width={360} height={270} encoding={{
          color: {
            type: 'nominal',
            field: 'id',
            scale: {
              type: 'ordinal',
              range: ['#4ECDC4', '#C7F464', '#FF6B6B', '#C44D58']
            }
          },
          pattern: {
            value: 'lines'
          },
          size: {
            type: 'quantitative',
            field: 'value'
          },
          label: {
            field: 'id'
          }
        }} data={[{
          "id": "python",
          "value": 376
        }, {
          "id": "javascript",
          "value": 392
        }, {
          "id": "ruby",
          "value": 331
        }, {
          "id": "scala",
          "value": 184
        }]} mdxType="DonutChart" />
  </Frame>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      